var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-transport-bg-orange';
                    var viewUrl = 'sprite.svg#view-icon-transport-bg-orange';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 75 43',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };